var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alleles-donut"},[_c('pie-chart',{attrs:{"height":"200px","legend":"bottom","data":_vm.data,"colors":[_vm.a2Color, _vm.a1Color],"donut":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }